import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import SkipPanVerification from '../SkipPanVerification/SkipPanVerification';
import OtpField from '../../../CommonComponents/OtpField/OtpField';
import TextInput from '../../../CommonComponents/TextInput/TextInput';
import OtpVerified from '../../../CommonComponents/OtpVerified/OtpVerified';
import {
  submitPanVerificationOtpData,
  getPanVerificationData,
  skipPanVerificationData,
} from '../../../../../../store/actions/thunk';
import * as S from './VerifyPAN.styles';

//TODO: Add in different file
const options = [
  {
    id: '756',
    text: 'I do not have access to the linked mobile',
  },
  {
    id: '756sdkjhbv',
    text: 'I want to update PAN',
  },
  {
    id: '756skjd987',
    text: 'I want to update GSTN',
  },
  {
    id: '756Otherpleasespecify',
    text: 'Other, please specify',
  },
];

const VerifyPAN = ({panVerificationData, responseRedirectUrl, screenToShow}) => {
  const dispatch = useDispatch();
  const winSize = window.screen;
  const [panNumber, setPanNumber] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loader, setLoader] = useState(false);
  const [step, setStep] = useState(2);
  const [skipVerificationResponseData, setSkipVerificationResponseData] = useState(null);
  const [otherReasontoSkip, setOtherReasonToSkip] = useState('');
  const [idx, setIdx] = useState(-1);
  const [maxRetryCount, setMaxRetryCount] = useState(0);
  const [resendOtpLoader, setResendOtpLoader] = useState(false);
  const [submitSkipVerifyPan, setSubmitSkipVerifyPan] = useState(false);
  const [submitOtpSuccesData, setSubmitOtpSuccessData] = useState({});

  useEffect(() => {
    if (panVerificationData?.subHeading) {
      const panNumberString = panVerificationData.subHeading.replace(/ .*/, '');
      setPanNumber(panNumberString);
    }
    if (panVerificationData?.maxOtpLimit) {
      setMaxRetryCount(panVerificationData?.maxOtpLimit);
    }
  }, [panVerificationData]);

  useEffect(() => {
    setScreenStep(screenToShow);
  }, [screenToShow]);

  const setScreenStep = screen => {
    if (screen === 'GSTN_PAN_Verification') {
      setStep(2);
    } else if (screen === 'Aadhar_PAN_Verification') {
      setStep(1);
    } else if (screen === 'tdsSlabInformation') {
      setStep(6);
    }
  };

  const onChange = otp => {
    if (otp.length === 6) {
      setLoader(true);
      dispatch(
        submitPanVerificationOtpData(
          otp,
          'verifyOtp',
          submitOtpSuccessCallback,
          submitOtpErrorCallback,
        ),
      );
    }
  };

  const submitOtpSuccessCallback = response => {
    setLoader(false);
    setSubmitOtpSuccessData(response);
    setStep(4);
  };

  const submitOtpErrorCallback = err => {
    setErrorMsg(err);
    setLoader(false);
  };

  const onBackPress = () => {
    setStep(step => step - 1);
  };

  const handleVerifyLater = () => {
    setStep(3);
  };

  const handleResendOtp = () => {
    if (maxRetryCount) {
      setMaxRetryCount(maxRetryCount => maxRetryCount - 1);
      setResendOtpLoader(true);
      dispatch(
        getPanVerificationData(resendOtpSuccessCallback, resendOtpErrorCallback, maxRetryCount),
      );
    } else {
      setErrorMsg('Max resend count reached');
    }
  };

  const resendOtpSuccessCallback = response => {
    setResendOtpLoader(false);
    setErrorMsg('');
  };

  const resendOtpErrorCallback = err => {
    setResendOtpLoader(false);
    setErrorMsg(err?.msg);
  };

  const skipPanVerificationOptionChange = index => {
    setIdx(index);
  };

  const handleSkipPanVerification = () => {
    if (idx !== -1) {
      setSubmitSkipVerifyPan(true);
      if (idx === 3 && otherReasontoSkip) {
        dispatch(
          skipPanVerificationData(
            otherReasontoSkip,
            'verifyLater',
            handleSkipPanVerificationSuccessCallback,
            handleSkipPanVerificationErrorCallback,
          ),
        );
      } else {
        dispatch(
          skipPanVerificationData(
            options[0].text,
            'verifyLater',
            handleSkipPanVerificationSuccessCallback,
            handleSkipPanVerificationErrorCallback,
          ),
        );
      }
    }
  };

  const handleSkipPanVerificationSuccessCallback = response => {
    setSubmitSkipVerifyPan(false);
    setStep(5);
    setErrorMsg('');
    setSkipVerificationResponseData(response);
  };

  const handleSkipPanVerificationErrorCallback = err => {
    setSubmitSkipVerifyPan(false);
    setErrorMsg(err?.msg);
  };

  return (
    <S.VrfyPan>
      {step === 2 && (
        <>
          <S.VrfyPanHdr>
            <S.Heading>{panVerificationData?.heading}</S.Heading>
            {winSize.width > 768 && (
              <S.SmallText onClick={handleVerifyLater}>Verify later</S.SmallText>
            )}
          </S.VrfyPanHdr>
          <S.SubHeading>
            <span className="latoBlack">{panNumber}</span> - PAN linked to your myPartner profile
          </S.SubHeading>
          <S.Info>
            <span className="icon">
              <img src="./assets/info-icon.png" alt="" />
            </span>
            <p>
              Starting April 1st 2023, myPartner will begin the process of filing TDS against the
              registered PAN.
            </p>
          </S.Info>
          <S.SubHeading>
            Please enter the 6-digit OTP sent to the{' '}
            <span className="latoBlack">mobile {panVerificationData?.gstnMobile}</span> linked to
            your <span className="latoBlack">GSTN - {panVerificationData?.gstnNumber}</span> to
            verify that the above PAN is yours.
          </S.SubHeading>
          <S.Content>
            <OtpField
              labelText="Enter OTP"
              resendOtp="Resend OTP"
              onChange={onChange}
              loader={loader}
              handleResend={handleResendOtp}
              resendOtpLoader={resendOtpLoader}
            />
          </S.Content>
          {errorMsg && <S.ErrMsg>{errorMsg}</S.ErrMsg>}
        </>
      )}
      {step === 3 && (
        <SkipPanVerification
          onBackPress={onBackPress}
          options={options}
          infoText="It is mandatory to verify the PAN before 1st April 2023"
          infoIcon="./assets/info-icon.png"
          cta="Continue"
          handleSkipPanVerification={skipPanVerificationOptionChange}
          handleSubmit={handleSkipPanVerification}
          setOtherReasonToSkip={setOtherReasonToSkip}
          otherReasontoSkip={otherReasontoSkip}
          submitSkipVerifyPan={submitSkipVerifyPan}
        />
      )}
      {step === 4 && (
        <OtpVerified
          heading="PAN Ownership Verified"
          headingIcon="./assets/green-tick.png"
          subHeading=""
          message="Continue to Account"
          timer="00:10 sec"
          inportantInfo={`<span class='latoBlack'>*Important:</span> ${submitOtpSuccesData?.sub_heading}`}
          panVerified={true}
          responseRedirectUrl={responseRedirectUrl}
        />
      )}
      {step === 5 && (
        <OtpVerified
          heading={skipVerificationResponseData?.heading}
          message="Continue to Account"
          timer="00:10 sec"
          inportantInfo="<span class='latoBlack'>*Important:</span> We strongly recommend that you <span class='latoBlack'>complete the PAN verification before 1st April 2023</span>. You may not be able to access your myPartner account without completing the verification process."
          panVerified={true}
          responseRedirectUrl={responseRedirectUrl}
        />
      )}
      {step === 6 && (
        <OtpVerified
          heading={panVerificationData?.heading}
          headingIcon=""
          subHeading={''}
          message="I Accept"
          timer="00:10 sec"
          inportantInfo={`${panVerificationData?.sub_heading}`}
          panVerified={true}
          responseRedirectUrl={responseRedirectUrl}
          tncClause={panVerificationData?.tnc_clause}
        />
      )}
      {/* {<S.SubHeading>
        To verify that the above PAN belongs to you,{' '}
        <span className="latoBlack">please enter the Aadhaar that is linked to the above PAN</span>
      </S.SubHeading>
      <TextInput placeholder="Enter your Aadhar that linked  to the PAN" />} */}
      {/* {<div className="textRight appendTop40">
        <S.BtnVerify isDisable={true}>verify</S.BtnVerify>
      </div>} */}
      {winSize.width < 768 && step === 2 && (
        <S.SmallText onClick={handleVerifyLater}>Verify later</S.SmallText>
      )}
    </S.VrfyPan>
  );
};

export default VerifyPAN;
